<template>
  <overlay v-model="show">
    <div slot="overlay-static">
      <input
        class="form-control"
        :class="{ 'form-control-sm': size == 'sm' }"
        ref="input"
        v-model.lazy="formatted"
        @keydown.tab="show = false"
        @focus="show = true"
      />
    </div>
    <div class="card-body">
      <div class="row flex-nowrap">
        <div class="col">
          <h5>
            <div class="row my-3">
              <div class="col-auto"><i class="fa fa-angle-left" role="button" @click="prevMonth"></i></div>
              <div class="col text-center">{{ current.format('MMMM') }} {{ current.format('YYYY') }}</div>
              <div class="col-auto text-right"><i class="fa fa-angle-right" role="button" @click="nextMonth"></i></div>
            </div>
          </h5>
          <table class="table table-sm">
            <thead>
              <tr>
                <th class="py-2 text-center" v-for="d in weekdays">{{ d }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="week in weeks">
                <td class="text-center" v-for="day in week">
                  <div
                    class="btn btn-circle"
                    role="button"
                    :class="{ 'btn-primary': day && day.isSame(selected, 'day') }"
                    v-if="day"
                    @click="select(day)"
                  >
                    {{ day.format('D') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center">
            <em class="text-muted">{{ selected.fromNow() }}</em
            ><br /><em
              ><a @click="selectNow">{{ 'now' | t }}</a></em
            >
          </div>
        </div>
        <div class="col align-self-center mx-5" v-show="!dateonly">
          <div class="row d-flex justify-content-around" style="font-size: 1rem">
            <i class="fa fa-angle-up fa-2x" @click="emit(selected.clone().add(1, 'hour'))"></i
            ><i class="fa fa-angle-up fa-2x" @click="emit(selected.clone().add(1, 'minute'))"></i>
          </div>
          <div class="row">
            <div class="display-4" style="white-space: nowrap">
              <input
                class="text-right input-clean"
                @change="emit(selected.clone().hour($event.target.value))"
                :value="selected.format('HH')"
                size="2"
                maxlength="2"
              /><span class="px-2">:</span>
              <input
                class="input-clean"
                @change="emit(selected.clone().minute($event.target.value))"
                :value="selected.format('mm')"
                size="2"
                maxlength="2"
              />
            </div>
          </div>
          <div class="row d-flex justify-content-around" style="font-size: 1rem">
            <i class="fa fa-angle-down fa-2x" @click="emit(selected.clone().subtract(1, 'hour'))"></i
            ><i class="fa fa-angle-down fa-2x" @click="emit(selected.clone().subtract(1, 'minute'))"></i>
          </div>
        </div>
      </div>
      <div class="text-right">
        <div class="btn btn-primary" role="button" @click="show = false">{{ 'ok' | t }}</div>
      </div>
    </div>
  </overlay>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-es6';

export default {
  props: ['value', 'size', 'dateonly'],
  data: function () {
    return {
      show: false,
      current: moment(),
      weekdays: moment.weekdaysShort(true)
    };
  },
  computed: {
    selected() {
      return this.value ? moment(this.value) || moment() : moment();
    },
    weeks() {
      var daysInMonth = [];

      var monthDate = this.current.clone().startOf('month').hour(this.current.hour()).minute(this.current.minute()); // change to a date in the month of interest
      var firstDayOfWeek = monthDate.format('e');

      _.times(monthDate.daysInMonth(), function (n) {
        daysInMonth.push(moment(monthDate)); // your format
        monthDate.add(1, 'day');
      });

      daysInMonth = _.concat(_.times(firstDayOfWeek, _.constant(null)), daysInMonth);

      return _.chunk(daysInMonth, 7);
    },
    formatted: {
      get() {
        if (this.dateonly) {
          return this.selected.format('YYYY-MM-DD');
        } else {
          return this.selected.format('YYYY-MM-DD HH:mm');
        }
      },
      set(v) {
        let m = this.dateonly ? moment(v, 'YYYY-MM-DD') : moment(v, 'YYYY-MM-DD HH:mm');

        if (m.isValid()) {
          this.emit(m);

          this.current = m.clone().startOf('month');
        }
      }
    }
  },
  watch: {
    formatted() {
      return this.emit(this.selected);
    }
  },
  methods: {
    emit(selected) {
      if (this.dateonly) {
        return this.$emit('input', selected.format('YYYY-MM-DD'));
      } else {
        return this.$emit('input', selected.format());
      }
    },
    select(day) {
      this.emit(day.hour(this.selected.hour()).minute(this.selected.minute()));
    },
    selectNow() {
      this.emit(moment());
      this.current = this.selected.clone().startOf('month').hour(this.selected.hour()).minute(this.selected.minute());
    },
    prevMonth() {
      this.current = this.current.clone().subtract(1, 'months');
    },
    nextMonth() {
      this.current = this.current.clone().add(1, 'months');
    }
  },
  mounted() {
    this.emit(this.selected);

    let input = this.$refs.input;
  }
};
</script>

<style scoped>
.form-control.form-control-sm {
  width: 100% !important;
}
</style>
